import { useRef } from 'react'
import { Downloader } from '@mote/helpers'
import type { QRCodeDisplayProps } from '../QRCodeDisplay'
import { QRCodeDisplay } from '../QRCodeDisplay'
import { Button } from '../button'
import {
  StyledSharePanelContainer,
  StyledSharePanelFooter
} from './CommonSharePanelStyles'
import { StyledQRCodeDisplayContainer } from './QRCodeSharePanel.styles'

export interface QRCodeSharePanelProps extends QRCodeDisplayProps {
  filename: string
  onSave: (src: string) => void
}

export function QRCodeSharePanel(props: QRCodeSharePanelProps) {
  const ref = useRef<HTMLDivElement>(null)

  function handleSave() {
    if (!ref.current) {
      return
    }
    const img = ref.current.querySelector('img')
    if (!img) {
      return
    }
    Downloader.getFromBlobUrl(img.src, props.filename)
    props.onSave(img.src)
  }

  return (
    <StyledSharePanelContainer ref={ref}>
      <StyledQRCodeDisplayContainer>
        <QRCodeDisplay url={props.url} />
      </StyledQRCodeDisplayContainer>
      <StyledSharePanelFooter>
        <Button
          //@ts-expect-error
          text='Save image'
          onClick={handleSave}
        />
      </StyledSharePanelFooter>
    </StyledSharePanelContainer>
  )
}
